import { filterSimple_template } from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/filterSimple_template";
import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";
import { sidebarMenu_template } from "./sidebarMenu_template";


declare var ko: any;

export class customEvents_template extends vnTemplate {

    protected searchField: filterSimple_template;
    public sidebarMenu: sidebarMenu_template;

    protected buildViewModel() {

        let self = this;

        return {
            customEvents: ko.observable([]),
            selectedEvent: ko.observable(null),

            edit_category: ko.observable(''),
            edit_name: ko.observable(''),
            edit_description: ko.observable(''),
            edit_isActive: ko.observable(false),
            edit_createdDate: ko.observable(null),

            edit_old_category: ko.observable(''),
            edit_old_name: ko.observable(''),

            create_category: ko.observable(''),
            create_name: ko.observable(''),
            create_description: ko.observable(''),

            isCreateOpen: ko.observable(false),
            isEditOpen: ko.observable(false),

            showMaxPopup: ko.observable(false),

            categoryError: ko.observable(null),
            nameError: ko.observable(null),
            descriptionError: ko.observable(null),
            generalError: ko.observable(null),

            onCloseMaxPopup: function() {

                self.onCloseMaxPopup();
            },
            openSidebar: function() {

                self.openSidebar();
            },
            onOpenCreate: function() {

                self.onOpenCreate();
            },
            onOpenEdit: function(dimension){

                self.onOpenEdit(dimension);
            },
            onCloseCreate: function(){

                self.onCloseCreate();
            },
            onCloseEdit: function(){

                self.onCloseEdit();
            },
            onSubmitEdit(){
                self.onSubmitEdit();
            },
            onSubmitCreate(){
                self.onSubmitCreate();
            },
            disabledCreate(){

                return self.disabledCreate();
            },
            disabledEdit(){

                return self.disabledEdit();
            },
            getStatusString: function(statusId) {

               return self.getStatusString(statusId);
            }
        }

    }

    private openSidebar(){

        this.sidebarMenu.setSidebarToggle(true);
    }

    protected getTemplateName(): string {

        return 'customEvents_template';
    }

    public onCloseMaxPopup(){

        this.getTemplateViewModel().showMaxPopup(false);
        this.clearErrors();
    }

    public onSubmitEdit() {

        this.caller.onSubmitEdit();
    }

    public onSubmitCreate(){

        this.caller.onSubmitCreate();
    }


    protected getMainElementClasses(): Array<string>{
        return ["page-content"];
    }


    public setCustomEvents(customEvents){

        this.getTemplateViewModel().customEvents(customEvents);
    }

    public onOpenCreate() {

        this.getTemplateViewModel().isCreateOpen(true);
    }

    public onOpenEdit(event) {

        this.getTemplateViewModel().selectedEvent(event);
        this.getTemplateViewModel().edit_category(event.category);
        this.getTemplateViewModel().edit_name(event.name);
        this.getTemplateViewModel().edit_description(event.description);
        this.getTemplateViewModel().edit_isActive(event.isActive);
        this.getTemplateViewModel().edit_createdDate(event.createdDate);

        // store old field values as they are used as the event key columns, which is necessary for retrieving the correct row to update on the server.
        this.getTemplateViewModel().edit_old_category(event.category);
        this.getTemplateViewModel().edit_old_name(event.name);

        this.getTemplateViewModel().isEditOpen(true);
    }

    public onCloseCreate() {

        this.getTemplateViewModel().create_category('')
        this.getTemplateViewModel().create_name('');
        this.getTemplateViewModel().create_description('');
        this.getTemplateViewModel().isCreateOpen(false);
        this.clearErrors();
    }

    public onCloseEdit() {

        this.getTemplateViewModel().selectedEvent(null);
        this.getTemplateViewModel().isEditOpen(false);
        this.clearErrors();
    }

    public clearErrors() {

        this.getTemplateViewModel().generalError(null);
        this.getTemplateViewModel().categoryError(null);
        this.getTemplateViewModel().nameError(null);
        this.getTemplateViewModel().descriptionError(null);
    }

    public disabledCreate() {

        const name = this.getTemplateViewModel().create_name();
        const category = this.getTemplateViewModel().create_category();

        return (!name || name == '' || !category || category == '');
    }

    public disabledEdit() {

        const name = this.getTemplateViewModel().edit_name();
        const category = this.getTemplateViewModel().edit_category();

        return (!name || name == '' || !category || category == '');
    }

    protected getTemplateHtml(): string {
        return `
            <div class="page-header">
                <button data-bind="event: { click: openSidebar }" class="button-default no-text icon i-hamburger preferences no-after"></button>
                <h2 style="display: none;" class="title-page">Custom Events</h2>
            </div>

            <div class="nav-page-container">
                <div class="nav-page-grid">

                    <div class="nav-page-sidebar">
                        ` + this.sidebarMenu.getHtmlBuild() + `
                    </div>

                    <div id="customEvents-results" class="nav-page-content">

                        <div class="block-default variation">
                            <div class="w-justify full-width">
                                <div class="w-left w-form">
                                    <div class="w-form-body">
                                        <div class="form-body form-body-header">
                                            <div class="form-group">
                                                <span class="form-sub-title">
                                                    Custom Events Page
                                                </span>
                                            </div>
                                            <div class="form-group">
                                                <p class="form-text">
                                                    To ensure accurate tracking and reporting, please follow these guidelines when creating custom events.
                                                </p>
                                            </div>
                                            <div class="form-group">
                                                <ul class="form-list" style="margin-bottom: 2.5rem;">
                                                    <li>A custom event cannot be deleted but can be deactivated.</li>
                                                    <li>Ensure each event is necessary before creating it.</li>
                                                </ul>
                                            </div>
                                        </div>
                                        <div class="form-body form-body-header">
                                            <div class="form-group">
                                                <span class="form-sub-title">
                                                    Event Structure
                                                </span>
                                            </div>
                                            <div class="form-group">
                                                <p class="form-text">
                                                    Each event consists of:
                                                </p>
                                            </div>
                                            <div class="form-group">
                                                <ul class="form-list">
                                                    <li><strong>Event Category</strong> A broad grouping of related events (e.g., "User Actions", "Purchases", "Videos").</li>
                                                    <li><strong>Event Name</strong> A specific action performed within the category (e.g., "Button Click", "Checkout", "Video Play").</li>
                                                    <li><strong>Event Value</strong> A numeric or text value tied to the Event Category and Event Name, passed by the site to capture relevant details (e.g., purchase amounts, video IDs, button labels).</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="w-right">

                                </div>
                            </div>
                        </div>

                        <div class="list-results-header w-justify">
                            <div class="w-left">
                               <button type="button" data-bind="click: onOpenCreate" class="button-default icon i-add-2"><span>Add Event</span></button>
                            </div>

                            <div class="w-center">
                                `+ this.searchField.getHtmlBuild() + `
                            </div>

                            <div class="w-right">

                            </div>
                        </div>

                        <div class="w-list-results taller">
                            <table class="list-results list-sections">
                                <thead>
                                    <tr>
                                        <th><span>Category</span></th>
                                        <th><span>Name</span></th>
                                        <th><span>Description</span></th>
                                        <th><span>Status</span></th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <!-- ko foreach: customEvents() -->
                                    <tr class="cursor" data-bind="click: function() { $parent.onOpenEdit($data) }">
                                        <td><span data-bind="text: $data.category"></span></td>
                                        <td><span data-bind="text: $data.name"></span></td>
                                        <td><span data-bind="text: $data.description"></span></td>
                                        <td><span data-bind="text: $parent.getStatusString($data.isActive)"></span></td>
                                    </tr>
                                    <!-- /ko -->
                                </tbody>
                            </table>
                        </div>

                    </div>
                </div>
            </div>

            <footer class="default-footer">
                <span class="logo-short"></span>
                <span class="footer-text">©${new Date().getFullYear()} ValServ Inc. All rights reserved.</span>
                <span>|</span>
                <a href="https://sentinelpro.com/pages/privacy-policy" target="_blank">Privacy Policy</a>
            </footer>


            <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isCreateOpen()}">
                <div class="lightbox-content">

                    <div class="w-form lightbox-form">
                        <div class="form-header">
                            <h3 class="form-title">Create custom event</h3>
                            <button type="button" data-bind="event: { click: onCloseCreate }" class="close-button icon i-close-2"></button>
                        </div>

                        <div class="form-body">

                            <div class="form-group" data-bind="css: {'is-error' : categoryError()}">
                                <label class="form-label">Category</label>
                                <div class="w-input">
                                    <input data-bind="value: create_category" type="text" name="category" id="category" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: categoryError()"></span>
                            </div>

                            <div class="form-group" data-bind="css: {'is-error' : nameError()}">
                                <label class="form-label">Name</label>
                                <div class="w-input">
                                    <input data-bind="value: create_name" type="text" name="name" id="name" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: nameError()"></span>
                            </div>

                            <div class="form-group" data-bind="css: {'is-error' : descriptionError()}">
                                <label class="form-label">Description</label>
                                <div class="w-input">
                                    <input data-bind="value: create_description" type="text" name="description" id="description" class="input-text">
                                </div>
                                <span class="form-error" data-bind="text: descriptionError()"></span>
                            </div>
                        </div>

                        <div class="form-footer">
                            <button data-bind="click: onCloseCreate" type="button" class="btn">Cancel</button>
                            <button data-bind="click: onSubmitCreate, disable: disabledCreate()" type="button" class="btn highlight">Add</button>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ko if: selectedEvent -->
                <div class="w-lightbox light-theme" data-bind="css: {'is-visible' : isEditOpen() && selectedEvent()}">
                    <div class="lightbox-content">

                        <div class="w-form lightbox-form">
                            <div class="form-header">
                                <h3 class="form-title">Edit event</h3>
                                <button type="button" data-bind="event: { click: onCloseEdit }" class="close-button icon i-close-2"></button>
                            </div>

                            <div class="form-body">
                                <div class="form-group" data-bind="css: {'is-error' : categoryError()}">
                                    <label class="form-label">Category</label>
                                    <div class="w-input">
                                        <input data-bind="value: edit_category" type="text" name="category" id="category" class="input-text">
                                    </div>
                                    <span class="form-error" data-bind="text: categoryError()"></span>
                                </div>
                                <div class="form-group" data-bind="css: {'is-error' : nameError()}">
                                    <label class="form-label">Name</label>
                                    <div class="w-input">
                                        <input data-bind="value: edit_name" type="text" name="name" id="name" class="input-text">
                                    </div>
                                    <span class="form-error" data-bind="text: nameError()"></span>
                                </div>
                                <div class="form-group" data-bind="css: {'is-error' : descriptionError()}">
                                    <label class="form-label">Description</label>
                                    <div class="w-input">
                                        <input data-bind="value: edit_description" type="text" name="description" id="description" class="input-text">
                                    </div>
                                    <span class="form-error" data-bind="text: descriptionError()"></span>
                                </div>
                                <div class="form-group">
                                    <input id="is-active" type="checkbox" data-bind="checked: edit_isActive">
                                    <label for="is-active" class="form-label icon i-check" style="line-height: 1;">Active</label>
                                </div>

                            </div>

                            <div class="form-footer">
                                <button data-bind="click: onCloseEdit" type="button" class="btn">Cancel</button>
                                <button data-bind="click: onSubmitEdit, disable: disabledEdit()" type="button" class="btn highlight">Save</button>
                            </div>
                        </div>

                    </div>
                </div>
            <!-- /ko -->
        `;
    }

    public getViewModelForRequest() {

        return {

            filters:{

                create_category: this.getTemplateViewModel().create_category(),
                create_name: this.getTemplateViewModel().create_name(),
                create_description: this.getTemplateViewModel().create_description(),

                edit_old_category: this.getTemplateViewModel().edit_old_category(),
                edit_old_name: this.getTemplateViewModel().edit_old_name(),

                edit_category: this.getTemplateViewModel().edit_category(),
                edit_name: this.getTemplateViewModel().edit_name(),
                edit_description: this.getTemplateViewModel().edit_description(),
                edit_isActive: this.getTemplateViewModel().edit_isActive() ? 1 : 0,
                edit_createdDate: this.getTemplateViewModel().edit_createdDate(),

                search: this.getTemplateViewModel().searchField.filterKeyword()
            }
        }
    }

    public getStatusString(statusId){

        switch(statusId){

            case 1: {
                return "Active";
            }
            case 0: {
                return "Inactive";
            }
            default: {
                return "inactive"
            }
        }
    }

    protected initPartial() {

        this.sidebarMenu = new sidebarMenu_template("sidebarMenu", this.getTemplateViewModel(), this.caller);
        this.sidebarMenu.setPageSelected('custom-events');

        this.searchField = new filterSimple_template("searchField", this.getTemplateViewModel(), this.caller);
    }

    public setSideMenuPermissionsData(data){

        this.sidebarMenu.setData(data);
    }


}



// WEBPACK FOOTER //
// ./js/components/templates/customEvents_template.ts